import { createAction } from 'redux-actions';

import {
  LOAD_TIME_SLOT_LIST,
  LOAD_TIME_SLOT_LIST_SUCCESS,
  LOAD_TIME_SLOT_LIST_ERROR,
  HOLD_BOOKING_SLOT,
  HOLD_BOOKING_SLOT_SUCCESS,
  HOLD_BOOKING_SLOT_ERROR,
  RELEASE_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT_SUCCESS,
  RELEASE_BOOKING_SLOT_ERROR,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  SAVE_SELECTED_BOOKING_SLOT,
  SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
  SAVE_SELECTED_BOOKING_SLOT_ERROR,
  CLEAR_SELECTED_BOOKING_SLOT,
  CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
  CLEAR_SELECTED_BOOKING_SLOT_ERROR,
  RESET_CURRENT_HOLDING_SLOT,
  RESET_TIME_SLOT_DATA,
} from './type';

//Load time slot list
export const loadTimeSlotListAction = createAction(
  LOAD_TIME_SLOT_LIST,
  payload => payload,
  meta => ({
    client: meta.client,
  }),
);
export const loadTimeSlotListSuccessAction = createAction(
  LOAD_TIME_SLOT_LIST_SUCCESS,
);
export const loadTimeSlotListErrorAction = createAction(
  LOAD_TIME_SLOT_LIST_ERROR,
);

export const holdBookingSlotAction = createAction(HOLD_BOOKING_SLOT);
export const holdBookingSlotSuccessAction = createAction(
  HOLD_BOOKING_SLOT_SUCCESS,
);
export const holdBookingSlotErrorAction = createAction(HOLD_BOOKING_SLOT_ERROR);

export const releaseBookingSlotAction = createAction(RELEASE_BOOKING_SLOT);
export const releaseBookingSlotSuccessAction = createAction(
  RELEASE_BOOKING_SLOT_SUCCESS,
);
export const releaseBookingSlotErrorAction = createAction(
  RELEASE_BOOKING_SLOT_ERROR,
);

export const bookAppointmentAction = createAction(BOOK_APPOINTMENT);
export const bookAppointmentSuccessAction = createAction(
  BOOK_APPOINTMENT_SUCCESS,
);
export const bookAppointmentErrorAction = createAction(BOOK_APPOINTMENT_ERROR);

export const saveSelectedBookingSlotAction = createAction(
  SAVE_SELECTED_BOOKING_SLOT,
);

export const saveSelectedBookingSlotSuccessAction = createAction(
  SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
);

export const saveSelectedBookingSlotErrorAction = createAction(
  SAVE_SELECTED_BOOKING_SLOT_ERROR,
);

export const clearSelectedBookingSlotAction = createAction(
  CLEAR_SELECTED_BOOKING_SLOT,
);
export const clearSelectedBookingSlotSuccessAction = createAction(
  CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
);
export const clearSelectedBookingSlotErrorAction = createAction(
  CLEAR_SELECTED_BOOKING_SLOT_ERROR,
);

export const resetCurrentHoldingSlotAction = createAction(
  RESET_CURRENT_HOLDING_SLOT,
);

export const resetTimeSlotDataAction = createAction(RESET_TIME_SLOT_DATA);
